export default class Stepper {
  constructor() {
    this.init();
  }
  init() {
    $(".esf-stepper").inputStepper();

    $(".stepper__input").change(function() {

      if ($(this).val().length == 0) {
        $(this).val(1);
      }
    });
  }
}
